import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import Icon from '@components/Icon';
import { Radio, Switch, Input, Slider, InputNumber, Select } from 'antd';
import ColorPicker from '@components/ColorPicker';
import stores from '@stores';
import { text2Svg } from '@utils/utils';

// 常用字体选项
const fontOptions = [
    { value: 'sans-serif', label: '无衬线体' },
    { value: 'serif', label: '衬线体' },
    { value: 'cursive', label: '手写体' },
    { value: 'fantasy', label: '奇幻体' },
    { value: 'monospace', label: '等宽字体' },
    { value: 'Arial, sans-serif', label: 'Arial' },
    { value: 'Verdana, sans-serif', label: 'Verdana' },
    { value: 'Georgia, serif', label: 'Georgia' },
    { value: 'Comic Sans MS, cursive', label: '可爱体' },
    { value: 'Pacifico, cursive', label: '艺术体' }
];

export default observer(() => {
    const [useWater, setUseWater] = useState(false);
    const [waterCont, setWaterCont] = useState('图美啦');
    const [waterColor, setWaterColor] = useState('#00000030');
    const [direction, setDirection] = useState(45);
    const [fontSize, setFontSize] = useState(36);
    const [fontFamily, setFontFamily] = useState('sans-serif');
    
    const handleColorChange = (color) => {
        setWaterColor(typeof color === 'string' ? color : color.toRgbString());
    };
    
    useEffect(() => {
        if (useWater && waterCont.trim()) {
            const svgImg = text2Svg({
                text: waterCont,
                color: waterColor,
                angleDegrees: direction,
                fontSize: fontSize,
                fontFamily: fontFamily
            });
            stores.option.setWaterImg(svgImg);
        } else {
            stores.option.setWaterImg(null);
        }
    }, [useWater, waterCont, waterColor, direction, fontSize, fontFamily]);
    
    return (
        <div>
            <div className="[&_label]:font-semibold [&_label]:text-sm flex gap-4 items-center justify-between">
                <label className="flex items-center font-medium">
                    启用水印
                </label>
                <Switch 
                    checked={useWater} 
                    onChange={setUseWater} 
                    size="small" 
                    className="bg-slate-200" 
                />
            </div>
            {useWater &&
                <div className="[&_label]:font-semibold [&_label]:text-xs grid gap-3 mt-3">
                    <Input 
                        value={waterCont} 
                        placeholder="水印内容" 
                        onChange={(e) => setWaterCont(e.target.value)} 
                    />
                    
                    {/* 字体选择 */}
                    <div className="flex items-center justify-between">
                        <label className="flex items-center">
                            <Icon.Type size={14} className="mr-1 text-purple-500 dark:text-purple-400" />
                            字体样式
                        </label>
                        <Select
                            size="small"
                            style={{ width: 120 }}
                            value={fontFamily}
                            onChange={setFontFamily}
                            options={fontOptions}
                        />
                    </div>
                    
                    {/* 字体大小 */}
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <label className="flex items-center">
                                <Icon.Type size={14} className="mr-1 text-purple-500 dark:text-purple-400" />
                                字体大小
                            </label>
                            <InputNumber
                                min={12}
                                max={100}
                                value={fontSize}
                                onChange={setFontSize}
                                size="small"
                                style={{ width: 70 }}
                                addonAfter="px"
                            />
                        </div>
                        <Slider
                            min={12}
                            max={100}
                            onChange={setFontSize}
                            value={fontSize}
                            step={1}
                            tooltip={{ formatter: (value) => `${value}px` }}
                        />
                    </div>
                    
                    <div className="flex items-center justify-between">
                        <label className="flex items-center">
                            <Icon.Pipette size={14} className="mr-1 text-purple-500 dark:text-purple-400" />
                            颜色
                        </label>
                        <ColorPicker value={waterColor} onChange={handleColorChange} size="small" />
                    </div>
                    
                    <div>
                        <div className="flex items-center justify-between mb-1">
                            <label className="flex items-center">
                                <Icon.RotateCcw size={14} className="mr-1 text-purple-500 dark:text-purple-400" />
                                旋转角度
                            </label>
                            <InputNumber
                                min={-180}
                                max={180}
                                value={direction}
                                onChange={setDirection}
                                size="small"
                                style={{ width: 70 }}
                                addonAfter="°"
                            />
                        </div>
                        <Slider
                            min={-180}
                            max={180}
                            onChange={setDirection}
                            value={direction}
                            step={5}
                            tooltip={{ formatter: (value) => `${value}°` }}
                        />
                    </div>
                    
                    <div className="flex items-center justify-between">
                        <label className="flex items-center">
                            <Icon.Box size={14} className="mr-1 text-purple-500 dark:text-purple-400" />
                            仅背景
                        </label>
                        <Switch size="small" onChange={(checked) => stores.option.setWaterIndex(checked ? -1 : 1)} className="bg-slate-200" />
                    </div>
                </div>
            }
        </div>
    )
});